import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import utils from "./utils";

import './assets/css/global.css'

// 导入富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
// 导入富文本编辑器样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import VueParticles from 'vue-particles'
Vue.use(VueParticles)
Vue.use(ElementUI)
// 全局注册富文本编辑器
Vue.use(VueQuillEditor)

import axios from 'axios'

axios.defaults.baseURL = 'http://localhost:8029'
axios.defaults.baseURL = 'https://yshop.douhuomall.com' // 测试
// axios.defaults.baseURL = 'https://yshop.wiwibao.com'    // 正式
axios.defaults.baseURL = ''  // 自送获取当前url
// axios.defaults.baseURL = 'http://localhost:8085'

if (process.env.NODE_ENV === 'production') {
    axios.defaults.baseURL = '';
}

axios.interceptors.request.use(config => {
    config.headers.sid = window.localStorage.getItem('sid')||0;
    config.headers.loginroletype = window.localStorage.getItem('loginroletype')||0;
    config.headers.uid = window.localStorage.getItem('uid')
    config.headers.token = window.localStorage.getItem('token');
    return config
})
let isLocation;
axios.interceptors.response.use(config => {
    if(config.data.code === undefined){
        return Promise.reject(config.data);
    }
	if(config.data.code === 1001&&!isLocation){
		isLocation = true;
		localStorage.clear();
		router.replace('/login')
		return true;
	}
    return config
})
Vue.prototype.$http = axios

Vue.prototype.$utils = utils;

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

//字符串补0
Vue.prototype.formatNumber = (n) => {
    n = n.toString()
    return n[1] ? n : '0' + n
}
Vue.prototype.formatTime = (number, format) => {
    var formateArr = ['Y', 'M', 'D', 'h', 'm', 's'];
    var returnArr = [];
    var date = new Date(number * 1000);
    returnArr.push(date.getFullYear());
    returnArr.push(Vue.prototype.formatNumber(date.getMonth() + 1));
    returnArr.push(Vue.prototype.formatNumber(date.getDate()));
    returnArr.push(Vue.prototype.formatNumber(date.getHours()));
    returnArr.push(Vue.prototype.formatNumber(date.getMinutes()));
    returnArr.push(Vue.prototype.formatNumber(date.getSeconds()));
    for (var i in returnArr) {
      format = format.replace(formateArr[i], returnArr[i]);
    }
    return format;
}

new Vue({
    router,
    el: '#app',
    render: h => h(App),
	  beforeCreate() {
		Vue.prototype.$bus = this;
	  }
})



// WEBPACK FOOTER //
// ./src/main.js